import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    paddingBottom: '3.2rem',
    marginTop: '4rem'
}))

export const ContentContainer = styled('div', ({ $theme }) => ({
    margin: '0 2rem'
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingSmall,
    fontWeight: 700,
    textAlign: 'center',
    margin: '0 0 1.6rem'
}))

export const Subtitle = styled('h2', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    fontWeight: 700,
    margin: '1.6rem 0'
}))

export const DetailsLine = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 0 1.6rem'
}))

export const Text = styled<'span', { $right?: boolean; $bold?: boolean }>(
    'span',
    ({ $theme, $right = false, $bold = false }) => ({
        ...$theme.typography.ParagraphMedium,
        fontWeight: $bold ? 700 : 300,
        textAlign: $right ? 'right' : 'left'
    })
)

export const Line = styled('div', ({ $theme }) => ({
    margin: '2rem 0',
    borderTop: '1px solid #F6F6F6'
}))

export const NightParkingTimesContainer = styled('div', ({ $theme }) => ({
    display: 'inline-flex',
    flexDirection: 'column',
    marginBottom: '1rem',

    [$theme.mediaQuery.large]: {
        gap: '0.6rem',
        flexDirection: 'row',
        marginBottom: 0
    }
}))

export const RightContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    textAlign: 'right'
}))

export const PriceText = styled('span', ({ $theme }) => ({
    fontSize: '2.9rem',
    fontWeight: 700,
    lineHeight: '2rem'
}))

export const VatText = styled('span', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    fontWeight: 300
}))

export const SectionTitle = styled('h3', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    fontWeight: 700,
    margin: '2rem 0 1.6rem'
}))

export const DescriptionTitle = styled('h4', ({ $theme }) => ({
    ...$theme.typography.LabelMedium,
    fontWeight: 700,
    margin: '1.6rem 0 0.4rem'
}))

export const Description = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    margin: 0,
    whiteSpace: 'pre-line'
}))

export const DownloadInvoice = styled('div', ({ $theme }) => ({
    cursor: 'pointer',
    color: $theme.colors.primary,
    textDecoration: 'underline',
    fontSize: '1.4rem',
    fontWeight: 700,
    lineHeight: '2rem'
}))

export const WarningTextContainer = styled('div', ({ $theme }) => ({
    ...$theme.typography.LabelXSmall,
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginTop: '1.6rem',
    backgroundColor: '#F7F7FF',
    color: $theme.colors.primary,
    padding: '16px 24px',
    borderRadius: '16px'
}))
